// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

var appContext = React.createContext({
      audioContext: undefined,
      triggerTargets: /* [] */0,
      addToTriggerTargets: (function (param) {
          
        }),
      removeFromTriggerTargets: (function (param) {
          
        }),
      setLfoOutputGain: (function (param) {
          
        }),
      lfoOutputGain: undefined
    });

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var make = appContext.Provider;

export {
  appContext ,
  makeProps ,
  make ,
  
}
/* appContext Not a pure module */
